import React, { useState } from 'react';

export default function DistributorClinicUserEditor({ row, disabled, onSave, onCancel, t }) {
  const [draft, setDraft] = useState({
    firstName: row.firstName,
    lastName: row.lastName,
    email: row.email,
    phone: row.phone || '',
    clinicRole: row.clinicRole || 'user',
  });
  const changes = Object.fromEntries(
    Object.entries(draft).filter(
      ([key, value]) => value !== (row[key] || (key === 'clinicRole' ? 'user' : ''))
    )
  );
  return (
    <form
      className="rounded-lg border bg-slate-50 p-4 space-y-3"
      aria-label={t('Edit clinic login')}
      onSubmit={(event) => {
        event.preventDefault();
        onSave(row, changes);
      }}
    >
      <h4 className="font-semibold">{t('Edit clinic login')}</h4>
      <fieldset disabled={disabled} className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {['firstName', 'lastName', 'email', 'phone'].map((key) => (
          <label key={key} className="text-sm">
            {t(
              {
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Account email',
                phone: 'Phone',
              }[key]
            )}
            <input
              className="block w-full mt-1 border rounded-lg px-3 py-2"
              type={key === 'email' ? 'email' : key === 'phone' ? 'tel' : 'text'}
              required={key !== 'phone'}
              maxLength={key === 'email' ? 254 : key === 'phone' ? 40 : 100}
              value={draft[key]}
              onChange={(event) => setDraft({ ...draft, [key]: event.target.value })}
            />
          </label>
        ))}
        <label className="text-sm">
          {t('Clinic role')}
          <select
            className="block w-full mt-1 border rounded-lg px-3 py-2"
            value={draft.clinicRole}
            onChange={(event) => setDraft({ ...draft, clinicRole: event.target.value })}
          >
            <option value="owner">{t('Owner')}</option>
            <option value="user">{t('User')}</option>
          </select>
        </label>
        <p className="sm:col-span-2 text-xs text-slate-500">
          {t(
            'Saving login changes signs this account out on all devices. Other logins keep their own credentials.'
          )}
        </p>
        <div className="sm:col-span-2 flex items-center gap-3">
          <button type="submit" disabled={!Object.keys(changes).length} className="me-dw-primary">
            {t('Save account')}
          </button>
          <button type="button" className="me-dw-link" onClick={onCancel}>
            {t('Cancel')}
          </button>
        </div>
      </fieldset>
    </form>
  );
}
